<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.cleanandafforest_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="type" slot-scope="scope">
        <el-tag v-show="scope.row.type == 1 && scope.row.cleanKeepingType == 1"
          >保洁：清洁楼道</el-tag
        >
        <el-tag v-show="scope.row.type == 1 && scope.row.cleanKeepingType == 2"
          >保洁：清洁车库</el-tag
        >
        <el-tag v-show="scope.row.type == 1 && scope.row.cleanKeepingType == 3"
          >保洁：清洁电梯</el-tag
        >
        <el-tag v-show="scope.row.type == 2 && scope.row.afforestType == 3">绿化：草坪</el-tag>
        <el-tag v-show="scope.row.type == 2 && scope.row.afforestType == 3">绿化：灌木</el-tag>
        <el-tag v-show="scope.row.type == 2 && scope.row.afforestType == 3">绿化：树</el-tag>
        <el-tag v-show="scope.row.type == 2 && scope.row.afforestType == 3">绿化：花</el-tag>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/cleanandafforest/cleanandafforest';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        searchMenuSpan: 6,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        column: [
          {
            label: '房产名称',
            prop: 'propertyId',
            rules: [
              {
                required: true,
                message: '请输入房产名称',
                trigger: 'change',
              },
            ],
            search: true,
            props: {
              label: 'title',
              value: 'id',
            },
            dicUrl: '/api/base/property/optionNode',
            type: 'select',
            dataType: 'number',
          },
          {
            label: '主类型',
            prop: 'type',
            rules: [
              {
                required: true,
                message: '请输入主类型',
                trigger: 'change',
              },
            ],
            dicData: [
              {
                label: '保洁',
                value: 1,
              },
              {
                label: '绿化',
                value: 2,
              },
            ],
            type: 'select',
            search: true,
          },
          {
            label: '保洁类型',
            prop: 'cleanKeepingType',
            dicData: [
              {
                label: '清洁楼道',
                value: 1,
              },
              {
                label: '清洁车库',
                value: 2,
              },
              {
                label: '清洁电梯',
                value: 3,
              },
            ],
            type: 'select',
          },
          {
            label: '绿化植被类型',
            prop: 'afforestType',
            dicData: [
              {
                label: '草坪',
                value: 1,
              },
              {
                label: '灌木',
                value: 2,
              },
              {
                label: '树',
                value: 3,
              },
              {
                label: '花',
                value: 4,
              },
            ],
            type: 'select',
          },
          {
            label: '负责人',
            prop: 'principalName',
            rules: [
              {
                required: true,
                message: '请输入负责人',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '工作内容',
            prop: 'jobContent',
            rules: [
              {
                required: true,
                message: '请输入工作内容',
                trigger: 'change',
              },
            ],
          },
          {
            label: '最后维护时间',
            prop: 'lastMaintainTime',
            rules: [
              {
                required: true,
                message: '请输入最后维护时间',
                trigger: 'change',
              },
            ],
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            type: 'datetime',
          },
          {
            label: '维护周期（天）',
            prop: 'maintainingIntervals',
            rules: [
              {
                required: true,
                message: '请输入维护周期（天）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.cleanandafforest_add, false),
        viewBtn: this.vaildData(this.permission.cleanandafforest_view, false),
        delBtn: this.vaildData(this.permission.cleanandafforest_delete, false),
        editBtn: this.vaildData(this.permission.cleanandafforest_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
